import React from 'react';

export const Star = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M21.803 6.08593C22.7017 4.26498 25.2983 4.26497 26.197 6.08593L31.0493 15.9179L41.8996 17.4945C43.9091 17.7865 44.7115 20.2561 43.2574 21.6735L35.4061 29.3266L37.2595 40.133C37.6028 42.1344 35.5021 43.6607 33.7047 42.7157L24 37.6136L14.2952 42.7157C12.4978 43.6607 10.3971 42.1344 10.7404 40.133L12.5938 29.3266L4.74255 21.6735C3.28843 20.2561 4.09083 17.7865 6.10037 17.4945L16.9506 15.9179L21.803 6.08593Z"
      fill="url(#paint0_linear_72095_8299)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_72095_8299"
        x1="43.9946"
        y1="43.8562"
        x2="2.87925"
        y2="5.05428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6F47" />
        <stop offset="1" stopColor="#FFCD0F" />
      </linearGradient>
    </defs>
  </svg>
);
